import React, { memo } from 'react';
import PropTypes from 'prop-types';

import { ReactComponent as NoItem } from 'assets/images/NoReview.svg';

import AppLink from 'components/App/AppLink';
import AppPoint from 'components/App/AppPoint';

import { LOCATIONS } from 'constants/index';
import { convertIsoDateToString } from 'utils';

import styles from './SectionReviews.module.scss';

function SectionReviews(props) {
  const { placeId, reviewList } = props;

  return (
    <section className={styles.SectionReview}>
      <div className={styles.Title}>
        <h3>Các đánh giá gần đây</h3>

        {reviewList.length > 0 && (
          <AppLink
            href={{
              pathname: LOCATIONS.LOCATION_DETAIL.DETAIL_REVIEWS,
              search: `?place=${placeId}`,
            }}
          >
            Xem tất cả
          </AppLink>
        )}
      </div>

      {reviewList.length > 0 ? (
        reviewList.map((item) => (
          <div className={styles.Item} key={item}>
            <div className={styles.ItemPoint}>
              <AppPoint point={item.overviewReview} />

              <p>{item.user.fullName}</p>
            </div>

            <p className={styles.ItemContent}>
              {item.content}
            </p>

            <div className={styles.ItemCreateAt}>
              <p>{convertIsoDateToString(item.createdAt)}</p>
            </div>
          </div>
        ))
      ) : (
        <div className={styles.EmptyItem}>
          <NoItem />

          <p>Bạn hiện chưa có đánh giá</p>
        </div>
      )}
    </section>
  );
}

SectionReviews.propTypes = {
  placeId: PropTypes.string.isRequired,
  reviewList: PropTypes.instanceOf(Array),
};

SectionReviews.defaultProps = {
  reviewList: [],
};

export default memo(SectionReviews);
